<template>
  <section>
    <b-button @click="$bvModal.show(modalId)" size="sm" variant="primary" class="mr-2">
      <i class="fa fa-plus" aria-hidden="true"></i>
      Add Item
    </b-button>
    <b-modal size="xl" :id="modalId" :ref="modalId" @show="resetModal(true)">
      <template slot="modal-header">
        <h5 class="modal-title">Add Item</h5>
      </template>
      <div>
        <b-row class="mb-2">
          <b-col cols="1"></b-col>
          <b-col cols="1">
            <b-form-group label="Purchase Order Number" >
              <label>{{serviceorder.purchaseOrderId}}</label>
            </b-form-group>
          </b-col>
          <b-col cols="2">
            <b-form-group label="Company" >
              <label>{{serviceorder.companyName}}</label>
            </b-form-group>
          </b-col>
          <b-col cols="2">
            <b-form-group label="Buyer" >
              <label>{{serviceorder.buyerUserFullName}}</label>
            </b-form-group>
          </b-col>
          <b-col cols="1">
            <b-form-group label="Purchase Order Date" >
              <label>{{date(serviceorder.poDate)}}</label>
            </b-form-group>
          </b-col>
        </b-row>
          <p class="mt-2">Select the part(s) to add to the work order. You will define the service items in the next step.</p>
          <grid-component
            isSortable
            :gridId="poLineGridId"
            :itemData="poLineData"
            :fields="linesFields"
            @checkedItem="checkedRowItemIds=$event"
          />
      </div>
      <template slot="modal-footer">
        <b-button variant="primary" @click="saveServiceOrder" :disabled="isSaving">
          <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save</b-button>
        <b-button @click="$bvModal.hide(modalId)">Cancel</b-button>
      </template>
    </b-modal>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import { GRID_ID } from '@/shared/constants';
import GridComponent from '@/shared/components/GridComponent';
import linesFields from './fields';
import { VENDOR_ID } from '@/shared/constants';
import { date } from '@/shared/filters';
export default {
  components: {
    GridComponent
  },
  props: {
    serviceorder: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      linesFields,
      modalId: 'add-service-order-modal',
      selectedRowItemId: 0,
      checkedRowItemIds: [],
      selectedPO: {},
      date,
      isSaving: false,
      poLineGridId: GRID_ID.PURCHASE_ORDER_LINES_FOR_SERVICE_ORDER,
    };
  },
  computed: {
    //...mapState('purchaseorders', ['lastOpenedId', 'purchaseorders']),
    ...mapGetters('serviceOrderLines', ['serviceOrderLinesById']),
    ...mapGetters('purchaseorders', ['poLinesByPoId']),
    serviceOrderLines() {
      return this.serviceOrderLinesById(this.serviceorder.id);
    },
    poLineData() {
      //here we have to remove already added purchase order line id from selection grid so
      //first get already added line item details and get purchaseOrderLineId
      let alreadyAdded = [];
      this.serviceOrderLines.map((line)=>{
        alreadyAdded.push(line.purchaseOrderLineId);
      });
      alreadyAdded = [...new Set(alreadyAdded)];

      //once get already added purchaseOrderLineId then filter and remove those id from purchase order line list
      let itemData = this.poLinesByPoId.filter((item) => (alreadyAdded.indexOf(item.id) == -1));
      return itemData.map((purchaseorder) => ({...purchaseorder,qtyToTest: ''}));
    },
    selectedPoLine() {
      return this.poLineData.filter(x => this.checkedRowItemIds.includes(x.id));
    }
  },
  methods: {
    ...mapMutations('purchaseorders', ['setItem']),
    ...mapActions('purchaseorders', ['getByPurchaseOrderId']),
    ...mapActions('serviceOrderLines', ['addLineToServiceOrder']),
    async resetModal(getData=false) {
      this.setItem({ resource: 'poLinesByPoId', payload: [] });
      if(getData && this.serviceorder.id && this.serviceorder.purchaseOrderId){
        await this.getByPurchaseOrderId(this.serviceorder.purchaseOrderId);
      }
    },

    async saveServiceOrder() {
      let insertData = [];
      this.selectedPoLine.map((x) => (
      insertData.push({id: 0,statusId: x.statusId,serviceOrderId:this.serviceorder.id,purchaseOrderLineId: x.id,quantity: x.qtyToTest})));
      if(insertData.length && insertData[0].serviceOrderId){
        try {
          this.isSaving = true;
          await this.addLineToServiceOrder(insertData);
          this.isSaving = false;
          this.resetModal();
          this.$bvModal.hide(this.modalId);
        } catch (e) {
          this.isSaving = false;
          /*console.log(e.message);*/
        }
      }
    }
  },
  watch: {

  },
  async mounted() {

  },
  beforeDestroy() {

  },

};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
  min-width: 800px;
}

.max-grid-height {
  max-height: 280px;
}
</style>
